module.exports = __webpack_public_path__ + "img/38.aad039c0.jpg";